<template>
  <div>
    <Breadcrumb :title="'Partner Information'"></Breadcrumb>
    <BaseSearchBar :config="searchPartner" @keyupSearch="filterGrid"></BaseSearchBar>
    <BaseToolBar :config="ToolbarConfig" @buttonClicked="partnerInfoToolBarClick"></BaseToolBar>
    <BaseGrid
      :mode="'editform'"
      :excelExport="excelExport"
      :config="GridConfig"
      @EditItem="EditPartner"
      @AttachItem="PartnerAttachment"
      :data="PartnerGridData"
    ></BaseGrid>
    <PartnerInfoForm
      ref="refPartnerInfoForm"
      :PartnerInfoFormConfig="PartnerInfoJSON"
      :PartnerModalLabel="modalConfig"
      @SaveComplete="refreshGrid"
    ></PartnerInfoForm>
    <PartnerDocumentDropoffForm
      ref="partnerDocument"
      :docModalConfig="docModalConfig"
      :filterCondition="filterCondition"
      :transactionRecord="selectedPartner"
    ></PartnerDocumentDropoffForm>
  </div>
</template>

<script>
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import $ from "jquery";
// Base Searchbar Implementation
import BaseSearchBar from "@/components/base/BaseSearchBar.vue";
import funcUtil from "@/services/funcUtil.js";
import BaseModelPartner from "@/models/BaseModelPartner.js";

// Base Toolbar Implementation
import BaseToolBar from "@/components/base/BaseToolbar.vue";
import toolbarUtility from "@/services/toolbarUtility.js";
import { GridConfig, ToolbarConfig } from "./PartnerInfoConfig.js";

// Base Grid Implementation
import BaseGrid from "@/components/base/BaseGrid.vue";
import apiUtil from "@/services/apiUtil.js";

// Add Partner screen
import PartnerInfoForm from "@/components/forms/PartnerForm.vue";

// Add Documnet screen
import PartnerDocumentDropoffForm from "@/components/forms/PartnerDocumentDropoffForm.vue";
import { isNullOrUndefined } from "util";
import {mapActions, mapGetters } from "vuex";
import BaseModelPartnerAffiliation from "@/models/BaseModelPartnerAffiliation.js";

var loader;
export default {
  name: "PartnerInfo",
  mixins: [apiUtil, funcUtil, toolbarUtility],
  components: {
    Breadcrumb,
    BaseSearchBar,
    BaseToolBar,
    BaseGrid,
    PartnerInfoForm,
    PartnerDocumentDropoffForm
  },
  data: function() {
    return {
      // Base Grid implementation
      partnerGridId: "partnerGrid",
      GridConfig: GridConfig,
      PartnerInfoMasterData: [],
      PartnerGridData:[],
      BaseModelPartnerAffiliation: BaseModelPartnerAffiliation,

      // Base Toolbar with Add Partner button implementation
      ToolbarConfig: ToolbarConfig,

      // Base Searchbar implementation
      searchPartner: {
        SearchData: ""
      },

      // Add/Edit Partner data modal implementation
      modalConfig: {
        modalName: "",
        modalAddorEdit: ""
      },

      PartnerInfoJSON: { parent: {}, children: {} },
      PartnerInfoFormJSON: {
       parent: {
         Id: "",
          PartnerID: "",
        FullName: "",
        Prefix:"",
        FirstName: "",
        MiddleName: "",
        LastName: "",
        Suffix:"",
        EntityName: "",

        TaxId: "",
        TSDocId: "",
        Domestic: "",
        PartnerStatus: "",
        DocumentDeliveryMethod: "",
        ReceiveFMV: "",
        HireDate: "",
        LeaveDate: "",
        EMail: "",
        Position: "",
        VestingAcceleration: "",

        Address1: "",
        Address2: "",
        City: "",
        State: "",
        PostalCode: "",
        Country: "",

        MailAddress1: "",
        MailAddress2: "",
        MailCity: "",
        MailState: "",
        MailPostalCode: "",
        MailCountry: "",

        Note: "",},
        children: {
          PartnerAffiliation: []
        }
      },

      // Document dropoff modal
      docModalConfig: {
        modalName: "Partner Documents",
        modalIdandRef: "docModal",
        isFooter: false
      },
      // Filter condition for Document dropoff modal
      filterCondition: {
        filter: "",
        limit: 500
      },
      selectedPartner:{}
    };
  },

  computed:{
    ...mapGetters("getModule", ["withFilter","getJoinedItemsFilter"]),
  },

  async mounted() {
    let self = this;
    // Tool bar grid setting
    //self._loadGridSettings(self.partnerGridId);

    //Bind databound event to grid
    var grid = $("#partnerGrid").data("kendoGrid");
    grid.bind("dataBound", self.UpdatePartnerInfoMasterData);

    // US #1214 : Partner Information Page - Hide Treasury Units       
    await self.getBaseGridData();
  },

  methods: {
     ...mapActions("postModule",["CreateAllItems","deleteAllItem","UpdateAllItems","CreateJoinedItems"]),
    async getBaseGridData() {
      await this.getPartnerData();
      this._loadGridSettings(this.partnerGridId)
    },
    
    UpdatePartnerInfoMasterData: function(fromFilter, filterMasterData) {
      if (fromFilter == true) {
        this.PartnerInfoMasterData = filterMasterData;
      } else {
        this.PartnerInfoMasterData = $("#partnerGrid")
          .data()
          .kendoGrid.dataSource.data();
      }
    },

    // Grid search
    filterGrid: function() {
      var currentMasterdata = this.PartnerInfoMasterData;

      let filteredData = this._filterGrid(
        this.PartnerInfoMasterData,
        this.searchPartner.SearchData
      );

      $("#partnerGrid")
        .data("kendoGrid")
        .dataSource.data(filteredData);
      this.UpdatePartnerInfoMasterData(true, currentMasterdata);
    },

    // Toolbar Add Partner butt, Export and Grid settings
    partnerInfoToolBarClick(e) {
      const self =this;
      e.preventDefault();
      if (e.id === "btnAddPartner") {
        self.AddPartner();
        window.$("#BaseModal").modal("toggle");
      }
      if(e.id == "btnBulkImportPartner") {
        this.$router.push("/configuration/partner/Upload");   
      }
      if(e.id == "btnRefresh"){
        self.refreshGrid();
      }
     
      
      
      self._baseToolBarEvents(self.partnerGridId, ...arguments);
    },
    refreshGrid: function(){        
      this.getPartnerData();    

    },

    async getPartnerData() {
      const self = this;  
      // US #1214 : Partner Information Page - Hide Treasury Units       
      let result = this.withFilter(self.GridConfig.list, "");      
       
      self.PartnerGridData = await _.filter(result,function(obj){
        return obj.FullName != "Treasury Units"
      })

    },

    //Add Partner method
    AddPartner: function() {
      // this.$refs.refPartnerInfoForm.$refs.refPartnerID.hidden = true;
      this.$refs.refPartnerInfoForm.getInputControls();
      this.$refs.refPartnerInfoForm.onPartnerStatusChange();
      this.modalConfig.modalName = "Add Partner";
      this.modalConfig.modalAddorEdit = "Add";
      this.PartnerInfoJSON = this.PartnerInfoFormJSON;
      
      this.PartnerInfoFormJSON.parent.Id = "";
      this.PartnerInfoFormJSON.parent.PartnerID = "";
      this.PartnerInfoFormJSON.parent.FullName = "";
      this.PartnerInfoFormJSON.parent.Prefix = "";
      this.PartnerInfoFormJSON.parent.FirstName = "";
      this.PartnerInfoFormJSON.parent.MiddleName = "";
      this.PartnerInfoFormJSON.parent.LastName = "";
      this.PartnerInfoFormJSON.parent.Suffix = "";
      this.PartnerInfoFormJSON.parent.EntityName = "";
      this.PartnerInfoFormJSON.parent.EMail="";

      this.PartnerInfoFormJSON.parent.TaxId = "";
      this.PartnerInfoFormJSON.parent.TSDocId = "";
      this.PartnerInfoFormJSON.parent.Domestic = "";
      this.PartnerInfoFormJSON.parent.PartnerStatus = "";
      this.PartnerInfoFormJSON.parent.DocumentDeliveryMethod = "";
      this.PartnerInfoFormJSON.parent.ReceiveFMV = "";
      this.PartnerInfoFormJSON.parent.HireDate = "";
      this.PartnerInfoFormJSON.parent.LeaveDate = "";
      this.PartnerInfoFormJSON.parent.Position = "";
      this.PartnerInfoFormJSON.parent.VestingAcceleration = "";

      this.PartnerInfoFormJSON.parent.Address1 = "";
      this.PartnerInfoFormJSON.parent.Address2 = "";
      this.PartnerInfoFormJSON.parent.City = "";
      this.PartnerInfoFormJSON.parent.State = "";
      this.PartnerInfoFormJSON.parent.Country = "";
      this.PartnerInfoFormJSON.parent.PostalCode = "";

      this.PartnerInfoFormJSON.parent.MailAddress1 = "";
      this.PartnerInfoFormJSON.parent.MailAddress2 = "";
      this.PartnerInfoFormJSON.parent.MailCity = "";
      this.PartnerInfoFormJSON.parent.MailState = "";
      this.PartnerInfoFormJSON.parent.MailCountry = "";
      this.PartnerInfoFormJSON.parent.MailPostalCode = "";

      this.PartnerInfoFormJSON.parent.Note = "";
      this.PartnerInfoFormJSON.children.PartnerAffiliation = [];
      this.$refs.refPartnerInfoForm.bCountryValid=true
      this.$refs.refPartnerInfoForm.bStateValid=true
      this.$refs.refPartnerInfoForm.bMailCountryValid=true
      this.$refs.refPartnerInfoForm.bMailStateValid=true
    },

    //Edit Partner method
    EditPartner: function(e) {
      const self = this;
      e.preventDefault();
      self.modalConfig.modalName = "Edit Partner";
      self.modalConfig.modalAddorEdit = "Edit";

      self.$refs.refPartnerInfoForm.getInputControls();
      self.$refs.refPartnerInfoForm.onPartnerStatusChange();
      self.$refs.refPartnerInfoForm.bCountryValid=true
      self.$refs.refPartnerInfoForm.bStateValid=true
      self.$refs.refPartnerInfoForm.bMailCountryValid=true
      self.$refs.refPartnerInfoForm.bMailStateValid=true

      var gview = window.$("#partnerGrid").data("kendoGrid");
      var dataItem1 = gview.dataItem(window.$(e.currentTarget).closest("tr"));
      var dataItem = JSON.parse(JSON.stringify(dataItem1));
     
      let response = this.getJoinedItemsFilter({
        parentConfig: GridConfig,
        parentId: dataItem.Id,
        keyToJoin: "Partner/Id",
        childConfigs: [BaseModelPartnerAffiliation]
      })

      self.PartnerInfoFormJSON = JSON.parse(JSON.stringify(response));

      self.PartnerInfoFormJSON.parent.ReceiveFMV =  self.PartnerInfoFormJSON.parent.ReceiveFMV == "Yes" ? true : false;
      self.PartnerInfoFormJSON.parent.VestingAcceleration =  self.PartnerInfoFormJSON.parent.VestingAcceleration == "Yes" ? true : false;

      self.PartnerInfoJSON = self.PartnerInfoFormJSON;
      // self.$refs.refPartnerInfoForm.$refs.refPartnerID.hidden = false;

      window.$("#BaseModal").modal("toggle");
    },

    //Partner Attachment method
    PartnerAttachment: function(e) {
      let self = this;
      e.preventDefault();
      var gview = window.$("#partnerGrid").data("kendoGrid");
      var dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));

      this.selectedPartner={...dataItem};
            //TEMP: Only for Transfer Page.. Building Partner Record for the Time Being
      this.selectedPartner.PartnerTitle=dataItem.FullName,
      this.selectedPartner.PartnerId=dataItem.Id
      this.selectedPartner.TransactionID=null
      this.selectedPartner.BusinessEvent="Partner"
      //this.filterCondition.filter = `PartnerId eq '${dataItem.Id}'`;
      this.filterCondition.batchQuery=true;

      this.filterCondition.filter = function(o){
        let partnerIdList=(o.PartnerIdList)? o.PartnerIdList.split(",").map(Number):[]
        return o.PartnerId == dataItem.Id || partnerIdList.includes(dataItem.Id)
      }

      self.$refs.partnerDocument.$refs.partnerDocumentMgr.resetDropZoneGrid();

      window.$("#docModal").modal("toggle");
    }
  }
};
</script>
